<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<!-- 入金／返金／振替（ラジオボタン）-->
<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center ">
    <mat-radio-group name="registType" color="warn" (change)="onChangeRadio($event.value)"
        class="search-condition-radio-frame" [(ngModel)]="registType"
        style="position: relative;border: solid 1px rgba(117, 62, 62, 0.12); border-radius: 5px; padding-right: 1em; margin-top: 15px;">
        <mat-label
            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
            登録種別</mat-label>
        <mat-radio-button class="radio-button-margin" [value]="3"
            style="margin-bottom: 10px!important; margin-top: 10px;" checked>SGKE020D(返金)</mat-radio-button>
    </mat-radio-group>

    <button type="button" mat-raised-button color="primary" class="btn"
        (click)="onClickRepayInfo()">SGKE090D(返金内容確認)</button>
</div>

<div class="henkinHouhouTouroku" *ngIf="registType=='3'">
    <app-sgke050d-regist [hyojiCndtFlg]="true" [kinkoMno]="kinkoMno" [kinkoRrkno]="kinkoRrkno" [repayMno]="repayMno"
        [recptFixNo]="recptFixNo" [remny]="remny" [kinkoUpdateSrno]="kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="kinkoexUpdatesequencenumber" (searchEmit)="search()" (msgEmit)="showMsg($event)"
        (clearMessageEmit)="clearErrorMsg()"></app-sgke050d-regist>
</div>